import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Country data with capitals
const countries = [
  { id:"AT", name:"Österreich", flag:"🇦🇹", capital:"Wien", lat:48.2082, lng:16.3738, year:"1995", pop:"9,1 Mio.", currency:"Euro €", region:"Mitteleuropa", founder:false, fact:"⭐ Unser Heimatland! Wien ist eine der lebenswertesten Städte der Welt." },
  { id:"BE", name:"Belgien", flag:"🇧🇪", capital:"Brüssel", lat:50.8503, lng:4.3517, year:"1952", pop:"11,6 Mio.", currency:"Euro €", region:"Westeuropa", founder:true, fact:"🏛️ In Brüssel sitzt die EU-Kommission – die Hauptstadt Europas!" },
  { id:"BG", name:"Bulgarien", flag:"🇧🇬", capital:"Sofia", lat:42.6977, lng:23.3219, year:"2007", pop:"6,5 Mio.", currency:"Lew", region:"Südosteuropa", founder:false, fact:"🌹 Bulgarien produziert 80% des weltweiten Rosenöls!" },
  { id:"HR", name:"Kroatien", flag:"🇭🇷", capital:"Zagreb", lat:45.8150, lng:15.9819, year:"2013", pop:"3,9 Mio.", currency:"Euro €", region:"Mitteleuropa", founder:false, fact:"🏖️ Kroatien hat über 1.200 wunderschöne Inseln!" },
  { id:"CY", name:"Zypern", flag:"🇨🇾", capital:"Nikosia", lat:35.1856, lng:33.3823, year:"2004", pop:"0,9 Mio.", currency:"Euro €", region:"Südeuropa", founder:false, fact:"🏝️ Die drittgrößte Insel im Mittelmeer!" },
  { id:"CZ", name:"Tschechien", flag:"🇨🇿", capital:"Prag", lat:50.0755, lng:14.4378, year:"2004", pop:"10,8 Mio.", currency:"Krone", region:"Mitteleuropa", founder:false, fact:"🏰 Prag wird 'Stadt der hundert Türme' genannt!" },
  { id:"DK", name:"Dänemark", flag:"🇩🇰", capital:"Kopenhagen", lat:55.6761, lng:12.5683, year:"1973", pop:"5,9 Mio.", currency:"Krone", region:"Nordeuropa", founder:false, fact:"🧱 LEGO wurde in Dänemark erfunden!" },
  { id:"EE", name:"Estland", flag:"🇪🇪", capital:"Tallinn", lat:59.4370, lng:24.7536, year:"2004", pop:"1,3 Mio.", currency:"Euro €", region:"Baltikum", founder:false, fact:"💻 Skype wurde in Estland erfunden!" },
  { id:"FI", name:"Finnland", flag:"🇫🇮", capital:"Helsinki", lat:60.1699, lng:24.9384, year:"1995", pop:"5,5 Mio.", currency:"Euro €", region:"Nordeuropa", founder:false, fact:"🧖 In Finnland gibt es mehr Saunas als Autos!" },
  { id:"FR", name:"Frankreich", flag:"🇫🇷", capital:"Paris", lat:48.8566, lng:2.3522, year:"1952", pop:"67,8 Mio.", currency:"Euro €", region:"Westeuropa", founder:true, fact:"🧀 Es gibt über 1.200 verschiedene französische Käsesorten!" },
  { id:"DE", name:"Deutschland", flag:"🇩🇪", capital:"Berlin", lat:52.5200, lng:13.4050, year:"1952", pop:"84,4 Mio.", currency:"Euro €", region:"Mitteleuropa", founder:true, fact:"🚗 Größtes EU-Land mit der stärksten Wirtschaft!" },
  { id:"GR", name:"Griechenland", flag:"🇬🇷", capital:"Athen", lat:37.9838, lng:23.7275, year:"1981", pop:"10,4 Mio.", currency:"Euro €", region:"Südeuropa", founder:false, fact:"🏛️ Die Wiege der Demokratie!" },
  { id:"HU", name:"Ungarn", flag:"🇭🇺", capital:"Budapest", lat:47.4979, lng:19.0402, year:"2004", pop:"9,7 Mio.", currency:"Forint", region:"Mitteleuropa", founder:false, fact:"♨️ Budapest hat die größten Thermalquellen Europas!" },
  { id:"IE", name:"Irland", flag:"🇮🇪", capital:"Dublin", lat:53.3498, lng:-6.2603, year:"1973", pop:"5,1 Mio.", currency:"Euro €", region:"Westeuropa", founder:false, fact:"☘️ Die grüne Insel mit dem Kleeblatt!" },
  { id:"IT", name:"Italien", flag:"🇮🇹", capital:"Rom", lat:41.9028, lng:12.4964, year:"1952", pop:"58,9 Mio.", currency:"Euro €", region:"Südeuropa", founder:true, fact:"🍕 Die Römischen Verträge wurden 1957 hier unterzeichnet!" },
  { id:"LV", name:"Lettland", flag:"🇱🇻", capital:"Riga", lat:56.9496, lng:24.1052, year:"2004", pop:"1,8 Mio.", currency:"Euro €", region:"Baltikum", founder:false, fact:"🌲 Über 50% des Landes ist Wald!" },
  { id:"LT", name:"Litauen", flag:"🇱🇹", capital:"Vilnius", lat:54.6872, lng:25.2797, year:"2004", pop:"2,8 Mio.", currency:"Euro €", region:"Baltikum", founder:false, fact:"🏀 Basketball ist hier Nationalsport!" },
  { id:"LU", name:"Luxemburg", flag:"🇱🇺", capital:"Luxemburg", lat:49.6116, lng:6.1319, year:"1952", pop:"0,7 Mio.", currency:"Euro €", region:"Westeuropa", founder:true, fact:"🏦 Kleines Land mit höchstem BIP pro Kopf!" },
  { id:"MT", name:"Malta", flag:"🇲🇹", capital:"Valletta", lat:35.8989, lng:14.5146, year:"2004", pop:"0,5 Mio.", currency:"Euro €", region:"Südeuropa", founder:false, fact:"🏝️ Das kleinste EU-Land!" },
  { id:"NL", name:"Niederlande", flag:"🇳🇱", capital:"Amsterdam", lat:52.3676, lng:4.9041, year:"1952", pop:"17,7 Mio.", currency:"Euro €", region:"Westeuropa", founder:true, fact:"🌷 25% des Landes liegt unter dem Meeresspiegel!" },
  { id:"PL", name:"Polen", flag:"🇵🇱", capital:"Warschau", lat:52.2297, lng:21.0122, year:"2004", pop:"37,7 Mio.", currency:"Zloty", region:"Mitteleuropa", founder:false, fact:"📚 14 UNESCO-Welterbestätten!" },
  { id:"PT", name:"Portugal", flag:"🇵🇹", capital:"Lissabon", lat:38.7223, lng:-9.1393, year:"1986", pop:"10,3 Mio.", currency:"Euro €", region:"Südeuropa", founder:false, fact:"🌊 Hat die längste Brücke Europas (12,3 km)!" },
  { id:"RO", name:"Rumänien", flag:"🇷🇴", capital:"Bukarest", lat:44.4268, lng:26.1025, year:"2007", pop:"19,0 Mio.", currency:"Leu", region:"Südosteuropa", founder:false, fact:"🏰 Heimat von Transsilvanien und Dracula!" },
  { id:"SK", name:"Slowakei", flag:"🇸🇰", capital:"Bratislava", lat:48.1486, lng:17.1077, year:"2004", pop:"5,4 Mio.", currency:"Euro €", region:"Mitteleuropa", founder:false, fact:"🏔️ Über 6.000 Höhlen in den Karpaten!" },
  { id:"SI", name:"Slowenien", flag:"🇸🇮", capital:"Ljubljana", lat:46.0569, lng:14.5058, year:"2004", pop:"2,1 Mio.", currency:"Euro €", region:"Mitteleuropa", founder:false, fact:"🐉 Die berühmte Drachenbrücke in Ljubljana!" },
  { id:"ES", name:"Spanien", flag:"🇪🇸", capital:"Madrid", lat:40.4168, lng:-3.7038, year:"1986", pop:"47,8 Mio.", currency:"Euro €", region:"Südeuropa", founder:false, fact:"🌞 Die meisten Sonnenstunden in Europa!" },
  { id:"SE", name:"Schweden", flag:"🇸🇪", capital:"Stockholm", lat:59.3293, lng:18.0686, year:"1995", pop:"10,5 Mio.", currency:"Krone", region:"Nordeuropa", founder:false, fact:"🎵 Zweitgrößter Musikexporteur der Welt!" }
];

// Create popup HTML
function createPopup(c: typeof countries[0]) {
  return `
    <div class="popup-content">
      <div class="popup-header">
        <span class="popup-flag">${c.flag}</span>
        <span>${c.name}</span>
      </div>
      <div class="popup-grid">
        <div class="popup-item">
          <div class="popup-label">🏛️ Hauptstadt</div>
          <div class="popup-value">${c.capital}</div>
        </div>
        <div class="popup-item">
          <div class="popup-label">📅 EU-Beitritt</div>
          <div class="popup-value gold">${c.year}${c.founder ? ' (Gründer)' : ''}</div>
        </div>
        <div class="popup-item">
          <div class="popup-label">👥 Einwohner</div>
          <div class="popup-value">${c.pop}</div>
        </div>
        <div class="popup-item">
          <div class="popup-label">💰 Währung</div>
          <div class="popup-value">${c.currency}</div>
        </div>
        <div class="popup-item">
          <div class="popup-label">🌍 Region</div>
          <div class="popup-value">${c.region}</div>
        </div>
        <div class="popup-item">
          <div class="popup-label">🇪🇺 Status</div>
          <div class="popup-value">${c.founder ? 'Gründerstaat' : 'Mitglied'}</div>
        </div>
      </div>
      <div class="popup-fact">${c.fact}</div>
    </div>
  `;
}

export function EUMap() {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<L.Map | null>(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    // Initialize map
    const map = L.map(mapRef.current, {
      center: [50, 10],
      zoom: 4,
      minZoom: 3,
      maxZoom: 8,
      zoomControl: true
    });
    mapInstanceRef.current = map;

    // Add dark tile layer
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png', {
      attribution: '© OpenStreetMap © CartoDB',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map);

    // Load country borders
    const euCodes = ['AUT','BEL','BGR','HRV','CYP','CZE','DNK','EST','FIN','FRA','DEU','GRC','HUN','IRL','ITA','LVA','LTU','LUX','MLT','NLD','POL','PRT','ROU','SVK','SVN','ESP','SWE'];
    const numericToAlpha: Record<string, string> = {
      '40':'AUT','56':'BEL','100':'BGR','191':'HRV','196':'CYP','203':'CZE',
      '208':'DNK','233':'EST','246':'FIN','250':'FRA','276':'DEU','300':'GRC',
      '348':'HUN','372':'IRL','380':'ITA','428':'LVA','440':'LTU','442':'LUX',
      '470':'MLT','528':'NLD','616':'POL','620':'PRT','642':'ROU','703':'SVK',
      '705':'SVN','724':'ESP','752':'SWE',
      '826':'GBR','578':'NOR','756':'CHE','688':'SRB','70':'BIH','499':'MNE',
      '8':'ALB','807':'MKD','804':'UKR','112':'BLR','498':'MDA','643':'RUS'
    };

    fetch('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json')
      .then(res => res.json())
      .then(world => {
        // @ts-ignore - topojson types
        const topojson = (window as any).topojson;
        if (!topojson) {
          console.error('TopoJSON not loaded');
          return;
        }
        const countriesGeo = topojson.feature(world, world.objects.countries);

        const europeFeatures = countriesGeo.features.filter((f: any) => {
          return numericToAlpha[f.id] !== undefined;
        });

        L.geoJSON({ type: 'FeatureCollection', features: europeFeatures } as any, {
          style: function(feature: any) {
            const alpha3 = numericToAlpha[feature.id];
            const isEU = euCodes.includes(alpha3);
            return {
              fillColor: isEU ? '#3b5998' : '#1a1a2e',
              fillOpacity: isEU ? 0.7 : 0.5,
              color: isEU ? '#ffd54f' : '#444466',
              weight: isEU ? 2.5 : 1,
              opacity: 1
            };
          },
          onEachFeature: function(feature: any, layer: any) {
            const alpha3 = numericToAlpha[feature.id];
            if (euCodes.includes(alpha3)) {
              layer.on({
                mouseover: function(e: any) {
                  e.target.setStyle({ fillColor: '#5b79b8', fillOpacity: 0.9, weight: 3 });
                },
                mouseout: function(e: any) {
                  e.target.setStyle({ fillColor: '#3b5998', fillOpacity: 0.7, weight: 2.5 });
                }
              });
            }
          }
        }).addTo(map);
      })
      .catch(err => console.error('Failed to load borders:', err));

    // Add markers for each capital
    countries.forEach(c => {
      const markerHtml = `<div class="capital-marker ${c.founder ? 'founder' : ''}"></div>`;

      const icon = L.divIcon({
        html: markerHtml,
        className: 'custom-marker',
        iconSize: [20, 20],
        iconAnchor: [10, 10],
        popupAnchor: [0, -12]
      });

      L.marker([c.lat, c.lng], { icon })
        .addTo(map)
        .bindPopup(createPopup(c), {
          maxWidth: 300,
          className: 'custom-popup'
        });
    });

    // Cleanup on unmount
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className="eu-map-view">
      <div className="map-header">
        <Link to="/" className="back-link">
          <ArrowLeft size={18} />
          Zurück
        </Link>
        <h1>🌍 EU-Karte</h1>
      </div>

      <div ref={mapRef} className="leaflet-map" />

      <div className="map-legend">
        <span className="legend-item">
          <span className="legend-dot founder" />
          Gründerstaat (1952)
        </span>
        <span className="legend-item">
          <span className="legend-dot member" />
          Beitritt später
        </span>
      </div>
    </div>
  );
}
